// MARK: React
import * as React from "react";
import { observer } from "mobx-react";
import "./style.scss";

// MARK: Api
import { SurveyStats } from "@startapp/mistral-admin-api";

// MARK: Icons
import RatedText from "../../../../components/RatedText";

// MARK: Resources
import strings from "../../../../resources/strings";

interface IProps {
	surveyStats: SurveyStats;
}

@observer
export default class AverageRateSection extends React.Component<IProps> {

	public render() {
		const { surveyStats } = this.props;
		return (
			<>
				<div className="averageRateSection">
					<div className="averageRateRow">
						<RatedText
							text={strings.surveys.stats.averageNps.title}
							grade={surveyStats.averageNps ? surveyStats.averageNps : 0}
							textSize={22}
							isBold={true}
						/>
						<p className="categoryDescription">{strings.surveys.stats.averageNps.description}</p>
					</div>

					<div className="averageRateRow">
						<RatedText
							text={strings.surveys.stats.averageRate.title}
							grade={surveyStats.averageRate ? surveyStats.averageRate : 0}
							textSize={22}
							isBold={true}
						/>
						<p className="categoryDescription">{strings.surveys.stats.averageRate.description}</p>
					</div>

					<div className="averageRateContainer">
						<div className="averageRateContainerQuestions">
							<p className="averageRateContainerQuestionsTitle">{strings.surveys.stats.forEachQuestion}</p>
							{
								surveyStats.questionStatsSections.map((questionStatsSection) => {
									return (
										<div key={questionStatsSection.title}>
											<p className="averageRateContainerQuestionsTitle">{questionStatsSection.title}</p>
											{
												questionStatsSection.questionStats.map((formQuestion) => (
													<RatedText
														key={formQuestion.question.id}
														text={formQuestion.question.title}
														grade={formQuestion.averageRate}
													/>
												))
											}
										</div>
									);
								})
							}
						</div>
					</div>
				</div>
				<>
				</>
			</>
		);
	}
}
